import { useCallback } from 'react';

import { type SetStateAction } from 'jotai';

import {
  ROOT_FOLDER_ID,
  type FolderCrumb,
  type FolderNode,
} from '../types/fileSystem.js';

export const useFolderNavigation = ({
  path,
  setPath,
}: {
  path: FolderCrumb[];
  setPath: (update: SetStateAction<FolderCrumb[]>) => void;
}) => {
  const currentFolderId = path.at(-1)?.folderId ?? ROOT_FOLDER_ID;
  const depth = path.length;

  const enterFolder = useCallback(
    (folder: FolderNode) => {
      setPath((prev) => [...prev, { folderId: folder.id, name: folder.name }]);
    },
    [setPath],
  );

  const goToCrumb = useCallback(
    (folderId: string) => {
      if (folderId === ROOT_FOLDER_ID) {
        setPath([]);
        return;
      }

      setPath((prev) => {
        const index = prev.findIndex((crumb) => crumb.folderId === folderId);

        return index === -1 ? prev : prev.slice(0, index + 1);
      });
    },
    [setPath],
  );

  const reset = useCallback(() => setPath([]), [setPath]);

  return { currentFolderId, depth, enterFolder, goToCrumb, reset };
};
